import { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import { api } from "@/lib/api";

const ROWS = [
  { key: "stocks", label: "Stock investors", dot: "bg-emerald-500", accent: "text-emerald-400", reverse: false },
  { key: "real_estate", label: "Real estate investors", dot: "bg-amber-600", accent: "text-amber-500", reverse: true },
];

const Card = ({ t, accent, testId }) => (
  <figure className="panel w-[300px] shrink-0 whitespace-normal p-6 sm:w-[380px]" data-testid={testId}>
    <div className="flex items-center justify-between">
      <div className="flex gap-0.5">
        {[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`h-4 w-4 ${i <= t.rating ? "fill-amber-500 text-amber-500" : "text-slate-700"}`} />)}
      </div>
      <Quote className={`h-5 w-5 ${accent}`} />
    </div>
    <blockquote className="mt-4 text-sm leading-relaxed text-slate-300">“{t.quote}”</blockquote>
    <figcaption className="mt-5 text-sm">
      <span className="font-medium text-white">{t.name}</span>
      {t.location && <span className="text-slate-500"> · {t.location}</span>}
    </figcaption>
  </figure>
);

function Row({ row, items }) {
  const base = [];
  while (base.length < 6) base.push(...items);
  const loop = [...base, ...base];
  return (
    <div className="overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_6%,black_94%,transparent)]" data-testid={`testimonials-row-${row.key}`}>
      <div className={`marquee-track marquee-slow flex gap-6 py-2 ${row.reverse ? "marquee-reverse" : ""}`}>
        {loop.map((t, i) => <Card key={`${t.id}-${i}`} t={t} accent={row.accent} testId={`testimonial-card-${t.id}-${i}`} />)}
      </div>
    </div>
  );
}

export default function Testimonials({ category }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/testimonials").then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  const rows = ROWS.filter((r) => !category || r.key === category)
    .map((row) => ({ row, items: items.filter((t) => t.category === row.key) }))
    .filter((r) => r.items.length);
  if (!rows.length) return null;

  return (
    <section className="py-24" data-testid="testimonials-section">
      <div className="container-x mb-10">
        <p className="eyebrow">Investor stories</p>
        <h2 className="mt-3 font-display text-3xl font-semibold tracking-tight text-white sm:text-4xl">What our investors say</h2>
      </div>
      <div className="space-y-8">
        {rows.map(({ row, items: list }) => (
          <div key={row.key}>
            <p className="container-x mb-4 flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-slate-400">
              <span className={`h-1.5 w-1.5 rounded-full ${row.dot}`} />{row.label}
            </p>
            <Row row={row} items={list} />
          </div>
        ))}
      </div>
    </section>
  );
}
